import "core-js/modules/es6.function.name";
//
//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
import { chartMixins } from './chartMixins';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'lineStackMul',
  mixins: [chartMixins],
  props: {
    value: Array,
    text: String,
    subtext: String,
    xAxis: Array,
    color: Array,
    showTitle: {
      type: Boolean,
      default: true
    },
    total: Array
  },
  data: function data() {
    return {
      dom: null
    };
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setParams: function setParams(value) {
      var vm = this;
      var legend = [];

      for (var i in value) {
        legend.push(value[i].name);
      }

      this.option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          show: this.showTitle,
          x: 'center',
          textStyle: {
            fontSize: 14
          }
        },
        "color": this.color,
        legend: {
          type: 'scroll',
          pageIconSize: [20, 10],
          top: '25px',
          data: legend,
          pageTextStyle: {
            color: '#fff'
          },
          textStyle: {
            color: '#fff'
          } //   formatter: function(name) {
          //     // 获取legend显示内容
          //     let data = vm.total;
          //     let tarValue = 0;
          //     for (let i = 0, l = data.length; i < l; i++) {
          //         if (data[i].name == name) {
          //             tarValue = data[i].value;
          //         }
          //     }
          //     return name + ' ' + tarValue;
          // },

        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          top: '50',
          containLabel: true
        },
        tooltip: {// trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            //坐标轴先
            lineStyle: {
              color: "#fff"
            }
          },
          splitLine: {
            lineStyle: {
              color: "#fff"
            },
            show: false
          },
          axisLabel: {
            //// 刻度标签
            color: "#fff",
            lineStyle: {
              fontSize: '12'
            }
          },
          data: this.xAxis
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            lineStyle: {
              color: "#f00"
            },
            color: '#fff'
          },
          splitLine: {
            lineStyle: {
              color: "#fff"
            },
            show: false
          },
          axisLine: {
            show: true,
            color: '#fff',
            lineStyle: {
              color: '#fff'
            }
          }
        },
        series: value
      };
      return this.option;
    },
    init: function init() {
      var _this = this;

      // alert(123)
      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.setOption(this.setParams(this.value));
      setTimeout(function () {
        _this.resize();
      });
      on(window, 'resize', this.resize);
    },
    setOption: function setOption(value) {
      this.dom.setOption(this.setParams(value));
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};